import { render, staticRenderFns } from "./EmployeesWithNoAccessAlertBanner.vue?vue&type=template&id=29d1e0e0"
import script from "./EmployeesWithNoAccessAlertBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeesWithNoAccessAlertBanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EmployeesWithNoAccessAlertBanner.vue?vue&type=style&index=0&id=29d1e0e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports